// Controller button-prompt glyphs for the menu hint bar. The menus speak the
// player's own controller: Xbox letters, PlayStation shapes, or Nintendo
// letters (whose A/B sit swapped relative to Xbox under the "standard" layout,
// so the BOTTOM face button reads "B" on a Switch Pro pad).

export type PadFamily = "xbox" | "playstation" | "nintendo";

export function padFamily(gp: Gamepad): PadFamily {
  const id = gp.id.toLowerCase();
  if (/playstation|dualshock|dualsense|wireless controller|sony|054c/.test(id)) return "playstation";
  if (/nintendo|057e|pro controller|joy-con|switch/.test(id)) return "nintendo";
  return "xbox";
}

/** Short human name for the "connected" toast (raw ids are vendor soup). */
export function padFriendlyName(gp: Gamepad): string {
  switch (padFamily(gp)) {
    case "playstation": return /dualsense|0ce6/i.test(gp.id) ? "DualSense" : "PlayStation controller";
    case "nintendo": return "Switch controller";
    default: return /xbox|xinput|045e/i.test(gp.id) ? "Xbox controller" : "Controller";
  }
}

export interface PadGlyphs {
  confirm: string;
  back: string;
  x: string;
  y: string;
  start: string;
  lb: string;
  rb: string;
}

const GLYPHS: Record<PadFamily, PadGlyphs> = {
  xbox: { confirm: "A", back: "B", x: "X", y: "Y", start: "☰", lb: "LB", rb: "RB" },
  playstation: { confirm: "✕", back: "○", x: "□", y: "△", start: "OPTIONS", lb: "L1", rb: "R1" },
  nintendo: { confirm: "B", back: "A", x: "Y", y: "X", start: "+", lb: "L", rb: "R" },
};

export const padGlyphs = (gp: Gamepad): PadGlyphs => GLYPHS[padFamily(gp)];
